<template>
    <div class="col-md-5">
        <div class="ibox dasboard_graph">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">Employees on Leave today</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox-content pt-0">
                <table class="table dataTable">
                    <thead class="" style="">
                        <tr class="table-head">
                            <td>
                                Name
                            </td>
                            <td class="text-right">
                                Job Position
                            </td>
                            <td class="text-right" >
                                Leave Type
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(employee, i) in leave_data" :index="i">
                            <tr class="table-row hover-bg" >
                                <td class="">
                                    {{employee.name}}
                                </td>
                                <td class="">
                                    {{employee.jobposition}}
                                </td>
                                <td class="">
                                    {{employee.leave_title}}
                                </td>
                            </tr>
                        </template>

                    </tbody>
                </table>
                <div v-if="leave_data.length == 0" class="list-no-data">
                    No records found.
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    import moment from 'moment';
    export default{

        props: ['pageurl'],

        components: {
        },
        data(){
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);

            return {

                leave_data: [],
                leave_count:0,
            }
        },
        methods:{


            getLeaveData()
            {

                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                // AbdullahFixed chnaged here pageurl to apiyrl

                axios.get(this.$api_url+'/employee/attendance/date')
                .then(function (response)
                {

                    if(response.data.length > 0)
                    {
                        this.leave_data =response.data;
                        this.leave_count = this.leave_data.length;
                    }
                    else
                    {
                        this.leave_data = [];
                    }

                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },

        },
        created: function(){
            this.getLeaveData();

        }
    }

</script>


